import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/gear.svg'

@Component({
  tag: 'cr-icon-gear',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconGear {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }

}
